import $ from "jquery";
import { application } from "../application/application";
import { forms } from "../framework/forms";

function init() {
    $(document).on("dblclick", ".manageCourse", function() {
        forms.showSpinner();
        window.location.href =
            application.baseUrl + "/course/index/" + $(this).attr("data-courseId");
    });
}

export const dashboardManageOpenCourses = {
    init: init
};
